import type { TipoFranja } from '../logica/franjas';
import type { NombreIcono } from './iconos';

/** Colores e icono de cada franja (RV Franja, `RV_FRANJA` de la pieza del diseño). */
export const ESTILO_FRANJA: Record<TipoFranja, { fondo: string; tinta: string; baldosa: string; icono: NombreIcono }> = {
    suplantacion: { fondo: 'var(--rv-soporte)', tinta: '#fff', baldosa: 'rgba(255,255,255,0.18)', icono: 'eye' },
    reservaria: { fondo: 'var(--rv-soporte)', tinta: '#fff', baldosa: 'rgba(255,255,255,0.18)', icono: 'headset' },
    'solo-lectura': { fondo: 'var(--rv-red)', tinta: '#fff', baldosa: 'rgba(255,255,255,0.18)', icono: 'lock' },
    impago: { fondo: 'var(--rv-red)', tinta: '#fff', baldosa: 'rgba(255,255,255,0.18)', icono: 'credit-card' },
    soporte: { fondo: 'var(--rv-ink)', tinta: '#fff', baldosa: 'rgba(255,255,255,0.14)', icono: 'headset' },
    cupo100: { fondo: 'var(--rv-red)', tinta: '#fff', baldosa: 'rgba(255,255,255,0.18)', icono: 'gauge' },
    prueba: { fondo: 'var(--rv-warning)', tinta: 'var(--rv-ink)', baldosa: 'rgba(255,255,255,0.4)', icono: 'clock' },
    baja: { fondo: 'var(--rv-warning)', tinta: 'var(--rv-ink)', baldosa: 'rgba(255,255,255,0.4)', icono: 'calendar-x' },
    cupo: { fondo: 'var(--rv-warning)', tinta: 'var(--rv-ink)', baldosa: 'rgba(255,255,255,0.4)', icono: 'gauge' },
};

/** Icono de cada franja (también para su tarjeta en la campana). */
export function iconoDeFranja(tipo: TipoFranja): NombreIcono {
    return ESTILO_FRANJA[tipo].icono;
}

